import axios, { AxiosStatusCode } from '../axios';
import * as phone from '../phone';
import * as strings from '../strings';

declare interface myWindow extends Window {
    readonly login: string;
}

declare const window: myWindow;

export declare interface SessionResp {
    userID: string;
    email: string;
    phone: string;
    firstName: string;
    lastName: string;
    company: string;
    balance: string;
}

let sess: Promise<SessionResp> | undefined;

export async function Session(): Promise<SessionResp> {
    if (typeof sess !== 'undefined') {
        return sess;
    }

    return sess = axios.get<SessionResp>('/sessions', {
        params: {
            'cache': window.localStorage.getItem('sessionCache'),
        },
    }).then(resp => {
        const sess = resp.data;
        try {
            sess.phone = strings.TrimPrefix(phone.Format(sess.phone), 'tel:');
        } catch {
            sess.phone = '';
        }
        return sess;
    }).catch((err: unknown) => {
        if (AxiosStatusCode(err) === 403) {
            ClearLoginToken();
        }
        throw err;
    });
}

export function ClearCache() {
    window.localStorage.setItem('sessionCache', String(parseInt(window.localStorage.getItem('sessionCache') ?? '0', 10) + 1));
    sess = void 0;
}

export function SetLoginToken(loginToken: string) {
    ClearCache();
    window.localStorage.setItem('loginToken', loginToken);
}

export function GetLoginToken() {
    return window.localStorage.getItem('loginToken');
}

export function ClearLoginToken() {
    window.localStorage.removeItem('loginToken');
}

// Redirect redirects users to the login page and returns `true`
// if there's no session.
export async function Redirect(returnLoc: string = window.location.href, login = window.login): Promise<boolean> {
    if (!GetLoginToken()) {
        window.location.href = `${login}?return=${encodeURIComponent(returnLoc)}`;
        return true;
    }

    try {
        await Session();
    } catch (err: unknown) {
        if (AxiosStatusCode(err) === 403) {
            window.location.href = login;
            return true;
        }
    }

    return false;
}

export declare interface LoginResponse {
    token: string;
}

export async function CreateSessionWithLoginToken(loginToken: string) {
    return axios.post<LoginResponse>('/sessions', null, {
        params: {
            'token': loginToken,
        },
    }).then(resp => SetLoginToken(resp.data.token));
}
